import axios from 'axios'
//请求文件
//request.js

//1创建axios实例
const instance = axios.create({
    baseURL: 'https://api.zhibo.yunji.world/',
    timeout: 10000
});

function request(config) {
    return instance(config);
}

export default request